export const RECEIVED_ACCESS_TOKEN = 'receivedAccessToken';
export const RECEIVED_UNIT_LIST = 'receivedUnitList';
export const RECEIVED_EVENT_LIST = 'receivedEventList';
export const CHECKING_AVAILIBILITY = 'checkingAvailibility';
export const PREPARE_BOOKING = 'prepareBooking';
export const RESET_EVENT_BOOKING = 'resetEventBooking';


// WEBPACK FOOTER //
// ./src/config/actionTypes.js